import React, { FunctionComponent, useState, useEffect } from 'react';
import { EventModel } from 'features/events/EventModel';
import { Card } from 'components/Card';
import ReactPaginate from 'react-paginate';
import paginationStyles from 'components/Pagination/styles.module.scss';
import { useMediaQuery } from 'react-responsive';

export interface PaginatedEventsProps {
  events: EventModel[];
  itemsPerPage: number;
}

export const PaginatedEvents: FunctionComponent<PaginatedEventsProps> = ({
  events,
  itemsPerPage
}) => {
  const [currentItems, setCurrentItems] = useState<EventModel[]>([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' });

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(events.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(events.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, events]);

  const handlePageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * itemsPerPage) % events.length;
    setItemOffset(newOffset);
  };

  return (
    <div className="container--wide">
      <h1>Events</h1>
      {currentItems.length && (
        <ul className="list--reset grid">
          {currentItems.map((event) => (
            <li className="col-xss-12 col-xs-6" key={event.id}>
              <Card
                id={event.id}
                url={`/events/${event.id}`}
                title={`${event.title}`}
                artworkKey={event.artworkKey}
                artworkMode={event.artworkMode}
                updatedTimestamp={event.lastUpdatedAt}
                isPrivate={event.isPrivate()}
                isActive={event.isLive()}
                type={'event'}
              />
            </li>
          ))}
        </ul>
      )}
      {pageCount > 1 && (
        <ReactPaginate
          containerClassName={paginationStyles['pagination']}
          pageClassName={paginationStyles['pagination__page']}
          pageLinkClassName={paginationStyles['pagination__link']}
          activeLinkClassName={paginationStyles['pagination__link--active']}
          previousLinkClassName={paginationStyles['pagination__link--prev']}
          nextLinkClassName={paginationStyles['pagination__link--next']}
          disabledLinkClassName={paginationStyles['pagination__link--disabled']}
          breakLabel="..."
          nextLabel="next ›"
          onPageChange={handlePageClick}
          marginPagesDisplayed={1}
          pageRangeDisplayed={isMobile ? 2 : 5}
          pageCount={pageCount}
          previousLabel="‹ prev"
          renderOnZeroPageCount={() => null}
        />
      )}
    </div>
  );
};
